import { render, staticRenderFns } from "./StarIcon.vue?vue&type=template&id=c0a26d36&scoped=true&"
import script from "./StarIcon.vue?vue&type=script&lang=js&"
export * from "./StarIcon.vue?vue&type=script&lang=js&"
import style0 from "./StarIcon.vue?vue&type=style&index=0&id=c0a26d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a26d36",
  null
  
)

export default component.exports